import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { LoginService } from '@user/data-access';

@Component({
  selector: 'sd-logout-from-current-device',
  templateUrl: 'logout-from-current-device.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent],
})
export class LogoutFromCurrentDeviceComponent {
  constructor(private loginService: LoginService) {}

  logout(): void {
    this.loginService.logout();
  }
}
